module.exports = __webpack_public_path__ + "img/top.c7328f4b.png";